module.exports = __webpack_public_path__ + "f60b915331cfccbb2143e46b1954a123.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-32.png
// module id = 1784
// module chunks = 0